import { createFileRoute } from '@tanstack/react-router';

import { OwnersTable } from '../features/demand/owners/components/OwnersTable';
import { ownersRouteSearchSchema } from '../features/demand/owners/ownersRouteSearch';

export const Route = createFileRoute('/demand/owners/')({
  validateSearch: ownersRouteSearchSchema,
  component: OwnersTable,
});
